import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { policyClient } from '../client';
import { useRef, useState } from 'react';

export let policiesLoader = createLoader({
  name: 'policies',
  fetch: (i: { instanceId: string }) => withAuth(() => policyClient.policy.list(i)),
  mutators: {
    create: (i: { name: string; slug: string; description: string }) =>
      withAuth(() => policyClient.policy.create(i))
  }
});

export let usePolicies = (instanceId: string | null) => {
  let policies = policiesLoader.use(instanceId ? { instanceId } : null);

  return {
    ...policies,
    createMutator: policies.useMutator('create')
  };
};

export let policyLoader = createLoader({
  name: 'policy',
  fetch: (i: { instanceId: string; policyId: string }) =>
    withAuth(() => policyClient.policy.get(i)),
  mutators: {
    update: (i: {
      policyId: string;
      instanceId: string;
      name?: string;
      slug?: string;
      description?: string;
      isDefault?: boolean;
    }) => withAuth(() => policyClient.policy.update(i))
  }
});

export let usePolicy = (policyId: string | null, instanceId: string | null) => {
  let policy = policyLoader.use(policyId && instanceId ? { policyId, instanceId } : null);

  return {
    ...policy,
    updateMutator: policy.useMutator('update')
  };
};
